import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RequireAuth from './requireAuth';
import DashboardHeader from './dashboardHeader';
import { pointsDashboardPath, propertiesPath } from '../../constants';
import Card from '../../components/dashboard/card';
import { faChurch, faGear } from '@fortawesome/free-solid-svg-icons';

const DASHBOARD_CARDS = [
    {
        to: pointsDashboardPath,
        icon: faChurch,
        title: 'Service Points',
        description: 'Manage church services and video items',
    },
    {
        to: propertiesPath,
        icon: faGear,
        title: 'Properties',
        description: 'Handle live settings and web messages',
    },
];

const Dashboard = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const mainStyle = {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.brand.linen,
        paddingTop: 'var(--nav-height)',
        minHeight: '100vh',
        boxSizing: 'border-box',
    };

    const eyebrowStyle = {
        fontFamily: theme.typography.fontFamily,
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: theme.palette.brand.brass,
        margin: '0 0 6px',
    };

    return (
        <div style={mainStyle}>
            <RequireAuth />

            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px 20px 32px' }}>
                <DashboardHeader eyebrow="Admin" heading="Dashboard" />

                <div style={eyebrowStyle}>Manage</div>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                        gap: '10px',
                        marginTop: '12px',
                    }}
                >
                    {DASHBOARD_CARDS.map((card) => (
                        <div key={card.to} onClick={() => navigate(card.to)} style={{ cursor: 'pointer' }}>
                            <Card icon={card.icon} title={card.title} description={card.description} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
